import { Input } from '@cointracker/styleguide/src/Input/Input';
import { SkeletonLine } from '@cointracker/styleguide/src/Skeleton';
import { useBoundCalculatorStore } from '../../Calculator/store';
import { valueInputLoading } from './Loading.css';

interface ValueInputProps {
  label: string;
  value: string;
  action: (value: string) => void;
  loading?: boolean;
}

const ValueInputLoading = () => {
  return (
    <div className={valueInputLoading}>
      <SkeletonLine height={18} />
      <SkeletonLine height={46} />
    </div>
  );
};

export const ValueInput = ({
  loading = false,
  ...props
}: ValueInputProps | { loading: boolean }) => {
  const selectedCurrency = useBoundCalculatorStore(
    (state) => state.selectedCurrency,
  );
  if (loading) return <ValueInputLoading />;

  const { label, value, action } = props as ValueInputProps;

  return (
    <Input
      numeric
      label={label}
      value={value}
      onChange={(e) => action(e.target.value)}
      prefix={selectedCurrency?.symbol}
    />
  );
};
